<template>
  <span>
    <div id="app">
      <v-app light>
        <v-toolbar
          :extended="$vuetify.breakpoint.smAndDown"
          color="bolsa-guinda"
          v-if="$vuetify.breakpoint.smAndDown"
          style="height: 140px"
        >
          <div class="navbar-left">
            <a href="https://www.uni.edu.pe" target="_blank">
              <img class="navbar-left-image" src="../../assets/logo_uni.png" />
            </a>
          </div>
          <v-toolbar-title class="logo--text" v-text="title"></v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
        <v-toolbar color="bolsa-guinda" v-else>
          <div class="navbar-left">
            <a href="https://www.uni.edu.pe" target="_blank">
              <img class="navbar-left-image" src="../../assets/logo_uni.png" />
            </a>
          </div>
          <v-toolbar-title class="logo--text" v-text="title"></v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
        <v-main>
          <section>
            <v-parallax :src="image" contain height="450">
            </v-parallax>
          </section>

          <section>
            <v-container v-if="news" class="news-item">
              <v-row>
                <v-col cols="12" class="new-title">
                  <h1>{{ news.title }}</h1>
                </v-col>
                <v-col cols="12" sm="12" class="new-subtitle">
                  <h4>{{ news.subtitle }}</h4>
                  <div class="tags">
                    <v-chip v-for="(tag, index) in news.tags" :key="index" color="blue" text-color="white">
                      {{ tag }}
                    </v-chip>
                  </div>
                </v-col>

                <v-col cols="12" sm="12" class="new-subtitle">
                  <h4>{{ new Date(news.createdAt).toLocaleString() }}</h4>
                </v-col>

                <v-col class="content" cols="12" sm="12" md="12">
                  <v-card>
                    <v-card-text>
                      <div v-html="news.content"></div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </section>

          <v-footer color="#9a999d">
            <v-layout row wrap align-center>
              <v-flex xs12>
                <a class="white--text ml-4">Términos y Condiciones de uso</a>
              </v-flex>
            </v-layout>
          </v-footer>
        </v-main>
      </v-app>
    </div>
  </span>
</template>

<script>
import ApiService from '../../services/api.service';
import image from '../../assets/img.jpg';

export default {
  name: 'landing',
  data () {
    return {
      title: 'AlumniUNI',
      IndexTab: 'tabAlumno',
      authError: '',
      authErrorMessage: '',
      loadingAuth: false,
      closedErrorSnackbar: true,
      news: null,
      image: image
    };
  },
  async created () {
    const id = this.$route.params.id;
    try {
      const url = ApiService.getEndpoint(`/news/${id}`);
      const response = await fetch(url);
      const data = await response.json();
      this.news = data;
      if (data.image) {
        this.image = data.image;
      }
    } catch (error) {
      console.error('Error al cargar la noticia:', error);
    }
  }
};
</script>
<style>
.navbar-left {
  height: 100%;
  padding: 5px 0;
  margin: 0 10px;
}
.navbar-left-image {
  height: 100%;
  width: auto;
}
.v-toolbar__title.logo--text {
  color: white;
}

.wrap-text {
  -webkit-line-clamp: unset !important;
}
.new-title, .new-subtitle  {
  text-align: center;
}
</style>
